export  default {
    getNoteTypes(state) {
        return state.noteTypes;
    },
};